module.exports = __webpack_public_path__ + "static/media/greg.bbe176e3.jpg";